import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle() {
    this.element.classList.toggle("collapsed");

    const targetState = this.element.dataset.state;
    const boards = document.querySelectorAll(".kanban-board");
    const boardsData = Array.from(boards).map(board => {
      const headers = board.querySelectorAll('.grid-header');
      const gridTemplate = Array.from(headers)
        .map(header => header.classList.contains("collapsed") ? '80px' : '1fr')
        .join(" ");

      const itemsToToggle = board.querySelectorAll(`.kanban-column-items[data-state="${targetState}"] .kanban-item`);

      return { board, gridTemplate, itemsToToggle };
    });

    boardsData.forEach(({ board, gridTemplate, itemsToToggle }) => {
      itemsToToggle.forEach(elem => elem.classList.toggle("hidden"));
      board.style.setProperty("grid-template-columns", gridTemplate);
    });
  }


}
